<template>
  <div 
    class="px-5 pt-8 pb-5">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status perubahan data menjadi <b class="font-weight-bold black--text">di{{ message.status }}</b> ?

                <div>
                  <ValidationObserver 
                    ref="form">
                    <v-form>

                      <div
                        class="mb-6 mt-5"  v-if="message.status === 'tolak'">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="rejected_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      

                      <div
                        class="mb-6 mt-5" v-if="message.status === 'terima' && approved_by.length > 0">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="approved_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      
                    </v-form>
                  </ValidationObserver>
                </div>
  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.komfirmasi"
            @keydown.esc="dialog.komfirmasi = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Peringatan Order
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.komfirmasi = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Maaf Order tidak dapat di proses karena sisa plafon tidak mencukupi
  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  width="120"
                  @click="dialog.komfirmasi = false;"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Tutup
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.bukti"
          @keydown.esc="dialog.bukti = false"
          v-if="dialog.bukti"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="">
            <v-card-title 
              class="d-flex align-center pb-4 text-right popup-header fs-18 font-weight-bold">
              
              Bukti Pembayaran

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.bukti = false; dialog.fullscreen = false; selected.bukti = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.bukti = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
            class="body-1 font-weight-light text-first line-text-second my-0" v-if="selected.detail.length > 0">

              <div class="mt-2">
                <img 
                  :src="selected.detail[0].bukti_lunas_url"
                  alt="Mitra Warung" 
                  style="width: 100%; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />
              </div>

              <v-card-text
                v-if="selected.detail[0].bukti_lunas_url.length === 0"
                class="pb-0 my-4" style="height: 200px; display: flex; align-items: center; justify-content: center;">
                <div class="text-center">
                  <v-img 
                    class="mx-auto"
                    contain
                    alt="vuetify"
                    :width="90"
                    :height="90"
                    :src="require('@/assets/image/empty.png')">
                    <!-- <template v-slot:placeholder>
                      <v-row
                        class=" "
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template> -->
                  </v-img>
                  <div class="mt-3 fs-16">
                    Belum Ada Data Foto
                  </div>
                </div>
              </v-card-text>

            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="dialog.bukti = false; dialog.fullscreen = false;"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
          
          <div class="d-flex align-center justify-space-between mb-3">
            <div class="color-dark-blue fs-22 font-weight-bold">
              Detail Order
            </div>
            <div class="d-flex align-center">
              <v-btn
                @click="exportPDF()"
                :loading="process.pdf"
                :disabled="process.load || process.pdf"
                elevation="2"
                color="#E53935"
                height="38"
                class="fs-13 white--text text-capitalize px-4"
                style="border-radius: 6px; letter-spacing: 0.3px;">
                <v-icon left size="16">mdi-file-pdf-box</v-icon>
                Export PDF
              </v-btn>
            </div>
          </div>

          <v-row
            class="mt-3"
            ref="printArea">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 8px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                  <v-row>
                    <v-col cols="12">
                      <div class="font-weight-bold">
                        Customers :
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pt-0">
                      <div>
                        <div class="fs-15 font-weight-bold">
                          {{ detail.customer_name }}
                        </div>
                        <div class="text-lowercase">
                          {{ detail.shipping_address }}, kel. {{ detail.shipping_village }}, kec. {{ detail.shipping_subdistrict }}
                          Kab. {{ detail.shipping_city }} - {{ detail.shipping_province }}
                        </div>
                      </div>
                      <table>
                        <tr>
                          <td class="">
                            Nama Toko
                          </td>
                          <td style="width: 40px" class="text-center">
                            : 
                          </td>
                          <td class="text-left font-weight-bold">
                            {{ detail.store_name }}
                          </td>
                        </tr>
                        <tr>
                          <td class="">
                            Tipe Toko
                          </td>
                          <td style="width: 40px" class="text-center">
                            :
                          </td>
                          <td class="text-left font-weight-bold">
                            {{ detail.store_type }}
                          </td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                      <div>
                        <table style="width: 100%;">
                          <tr>
                            <td class="font-weight-bold">
                              Nomer Order
                            </td>
                            <td style="width: 80px" class="text-center">
                              : 
                            </td>
                            <td class="text-right">
                              {{ detail.number }}
                            </td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">
                              Tanggal Order
                            </td>
                            <td style="width: 80px" class="text-center">
                              :
                            </td>
                            <td class="text-right">
                              {{ detail.input_datetime | datetime }}
                            </td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">
                              Nama Sales
                            </td>
                            <td style="width: 80px" class="text-center">
                              : 
                            </td>
                            <td class="text-right">
                              {{ detail.sales_name }}
                            </td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">
                              Order By
                            </td>
                            <td style="width: 80px" class="text-center">
                              : 
                            </td>
                            <td class="text-right">
                              {{ detail.orders_by === 'sales' ? detail.sales_name : detail.orders_by === 'customer' ? detail.customer_name : detail.orders_by }} <span class="text-capitalize">( {{ detail.orders_by }} )</span>
                            </td>
                          </tr>

                          <tr>
                            <td class="font-weight-bold">
                              Rencana Tanggal Kirim
                            </td>
                            <td style="width: 80px" class="text-center">
                              : 
                            </td>
                            <td class="text-right font-weight-bold">
                              <span v-if="detail.delivery_plan_date">
                                {{ (detail.delivery_plan_date) | date }}
                              </span>
                              <span v-else>
                                -
                              </span>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </v-col>
                    <v-col cols="12" class="my-8">
                      <div style="overflow: auto; ">
                        <table style="width: 100%;">
                          <tr>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Kode Barang
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Nama Barang
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Quantity
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Harga Per Unit
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Harga Bruto
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Diskon Promo
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Diskon Strata
                            </td>
                            <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                              Harga Net. 
                            </td>
                          </tr>
                          <tr v-for="(item, index) in detail.detail" :key="index">
                            <td style="border: 1px solid #ededed; padding: 10px;" class="">
                              {{ item.detail_varian_sku }}
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="">
                              {{ item.detail_varian_name }}
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="">
                              {{ `${(item.detail_total_in_dus*1) === 1 ? 0 : item.detail_qty_dus}.${item.detail_qty_lusin}.${(item.detail_total_in_dus*1) === 1 ? item.detail_qty_dus : item.detail_qty_pcs}` }}
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                              <!-- Rp {{ item.detail_qty_pcs !== 0 ? item.detail_price_pcs : item.detail_qty_lusin !== 0 ? item.detail_price_lusin : item.detail_price_dus }} -->
                              <span v-if="item.detail_qty_pcs !== 0">
                                {{ item.detail_price_per_pcs | number_dec }}
                              </span>
                              <span v-else-if="item.detail_qty_lusin !== 0">
                                {{ (item.detail_price_per_pcs*12) | number_dec }}
                              </span>
                              <span v-else-if="item.detail_qty_dus !== 0">
                                {{ Math.round(item.detail_price_per_pcs*item.detail_total_in_dus) | number_dec }}
                              </span>
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                              <!-- <span v-if="item.detail_qty_pcs !== 0">{{ item.detail_price_pcs | price }}</span>
                              <span v-else-if="item.detail_qty_lusin !== 0">{{ item.detail_price_lusin | price }}</span>
                              <span v-else-if="item.detail_qty_dus !== 0">{{ item.detail_price_dus | price }}</span> -->
                              {{ (item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }}
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                              {{ (((item.detail_discount*1))) | price }}
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                              {{ (((item.detail_strata_nominal*1)*(item.detail_qty_dus))) | price }}
                            </td>
                            <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                              {{ (((item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1)) - ((((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))))) | price }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div>
                        Total Qty: <span>{{ 
                          `${detail.detail.reduce((acc, item) => (item.detail_total_in_dus * 1) > 1 ? acc + item.detail_qty_dus : acc, 0)}.${detail.detail.reduce((acc, item) => acc + item.detail_qty_lusin, 0)}.${detail.detail.reduce((acc, item) => (item.detail_total_in_dus * 1) === 1 ? acc + item.detail_qty_dus : acc, 0) + (detail.detail.reduce((acc, item) => acc + item.detail_qty_pcs, 0))}` }}</span>, Total Item: {{ detail.detail.length }}
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                      <div class="fs-15">
                        <table style="width: 100%;">
                          <tr>
                            <td class="pa-2 font-weight-bold">
                              Harga Bruto
                            </td>
                            <td style="width: 80px" class="pa-2 text-center">
                              : 
                            </td>
                            <td class="pa-2 text-right">
                              {{ detail.total_nominal*1 | price }}
                            </td>
                          </tr>
                          <tr>
                            <td class="pa-2 font-weight-bold">
                              Diskon 
                            </td>
                            <td style="width: 80px" class="pa-2 text-center">
                              :
                            </td>
                            <td class="pa-2 text-right">
                              <!-- {{ detail.total_discount*1 | price }} -->
                                {{ detail.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))), 0) | price }}
                            </td>
                          </tr>
                          <!-- <tr>
                            <td class="pa-2 font-weight-bold">
                              PPN 11%
                            </td>
                            <td style="width: 80px" class="pa-2 text-center">
                              : 
                            </td>
                            <td class="pa-2 text-right">
                              {{ detail.sales_name }}
                            </td>
                          </tr> -->
                          <tr>
                            <td class="pa-2 font-weight-bold">
                              Harga Net
                            </td>
                            <td style="width: 80px" class="pa-2 text-center">
                              :
                            </td>
                            <td class="pa-2 text-right">
                              {{ (detail.total_nominal*1 - (detail.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))), 0))) | price }}
                            </td>
                          </tr>

                        </table>
                      </div>
                    </v-col>
                    <!-- <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Nomer Order
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.number }}
                        </div>
                      </div>
                    </v-col>
                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Nama Sales
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.sales_name }}
                        </div>
                      </div>
                    </v-col>

                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Nama Customer
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.customer_name }}
                        </div>
                      </div>
                    </v-col>

                    <v-col>
                      <div>
                        <div class="mb-1 input-label">
                          Tanggal Order
                        </div>
                        <div class="fs-18 font-weight-bold">
                          {{ detail.input_datetime | date }}
                        </div>
                      </div>
                    </v-col> -->
                  </v-row>

                  <!-- <v-row>
                    <v-col>
                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Alamat
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_address }}
                        </div>
                      </div>
                    </v-col>
                    <v-col>

                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Kelurahan
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_village }}
                        </div>
                      </div>

                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Kecamatan
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_subdistrict }}
                        </div>
                      </div>
                      </v-col>
                      <v-col>

                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Kabupaten
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_city }}
                        </div>
                      </div>

                      <div class="mb-2">
                        <div class="mb-1 input-label">
                          Provinsi
                        </div>
                        <div class="fs-16 font-weight-bold">
                          {{ detail.shipping_province }}
                        </div>
                      </div>

                    </v-col>
                    <v-col></v-col>
                  </v-row> -->
                </v-card-text>
              </v-card>

              <!-- <div class="mt-5">
                <v-card flat style="border-radius: 8px; border: 1px solid #E7E7E7;" class="pb-7">
                  <v-card-text>
                    <div class="fs-18 input-label mb-8">
                      Detail Produk
                    </div>

                    <div v-for="(item, index) in detail.detail" :key="index">
                      <v-card flat class="mb-5" style="background: #718ebf17; border-radius: 15px;">
                        <v-card-text>
                          <div class="fs-16 font-weight-bold label-input">
                            {{ item.detail_varian_name }}
                          </div>
                          <div>
                            <span>Kode SKU</span>: <span>{{ item.detail_varian_sku }}</span>
                          </div>

                          <v-divider class="my-4"></v-divider>

                          <v-row>
                            <v-col class="py-0 font-weight-medium">
                              Qty
                            </v-col>
                            <v-col class="py-0 font-weight-medium">
                              Qty Per Pcs
                            </v-col>
                            <v-col class="py-0 font-weight-medium">
                              Harga Per Pcs
                            </v-col>
                            <v-col class="text-right py-0 font-weight-medium">
                              Total
                            </v-col>
                          </v-row>

                          <v-row class="pt-3" v-if="item.detail_qty_pcs !== 0">
                            <v-col class="py-0">
        
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_qty_pcs }} Pcs
                              </div>
                            </v-col>
                            <v-col class="py-0">
        
                              <div class="fs-17 font-weight-bold label-input">
                                -
                              </div>
                            </v-col>
                            <v-col class="py-0">
        
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_price_per_pcs | price }} 
                              </div>
                            </v-col>
                            <v-col class="text-right py-0">
      
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_price_pcs | price }}
                              </div>
                            </v-col>
                          </v-row>

                          <v-row v-if="item.detail_qty_lusin*1 !== 0">

                            <v-col class="py-0">
        
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_qty_lusin }} Lusin
                              </div>
                            </v-col>
                            <v-col class="py-0">
        
                              <div class="fs-17 font-weight-bold label-input">
                                12
                              </div>
                            </v-col>
                            <v-col class="py-0">
        
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_price_per_pcs | price }} 
                              </div>
                            </v-col>
                            <v-col class="text-right py-0">
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_price_lusin | price }}
                              </div>
                            </v-col>
                          </v-row>

                          <v-row v-if="item.detail_qty_dus*1 !== 0">
                            <v-col class="py-0">
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_qty_dus }} Dus
                              </div>
                            </v-col>
                            <v-col class="py-0">
        
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_total_in_dus*1 }}
                              </div>
                            </v-col>
                            <v-col class="py-0">
        
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_price_per_pcs | price }} 
                              </div>
                            </v-col>
                            <v-col class="text-right py-0">
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_price_dus | price }}
                              </div>
                            </v-col>
                          </v-row>

                          <v-divider class="my-4"></v-divider>

                          <v-row>
                            <v-col class="label-input font-weight-bold ">
                              <div>
                                Sub Total
                              </div>
                            </v-col>
                            <v-col cols="12" md="4">
                              <div>
                                
                              </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-right">
                              <div class="fs-17 font-weight-bold label-input">
                                {{ item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1 | price }}
                              </div>
                            </v-col>
                          </v-row>

                        </v-card-text>
                      </v-card>
                    </div>


                    <div>
                      <v-card flat style="background: #718ebf17; border-radius: 15px;">
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" md="4">
                              <div class="label-input font-weight-bold ">
                                Grand Total
                              </div>
                            </v-col>
                            <v-col cols="12" md="4">
                              <div>
                                
                              </div>
                            </v-col>
                            <v-col cols="12" md="4" class="text-right">
                              <div class="fs-17 font-weight-bold label-input">
                                {{ detail.total_nominal*1 | price }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-card-text>
                </v-card>
              </div> -->

              <v-card
                flat
                class="mt-8"
                v-if="Object.keys(detail).length > 0"
                style="border-radius: 8px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div class="fs-18 input-label mb-4">
                    Titip Tagih
                  </div>

                  <div class="view">
                    <div v-if="!process.invoice && invoice.length !== 0">
                      <div :class="process.invoice || invoice.length === 0 ? '' : 'wrapper-detail-order'">
                        <table style="border-radius: 10px; width: 100%;" class="table">
                          <tr>
                            <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                            <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Kode Outlet
                              <span v-if="sortBy === 'customer_code'">
                                <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                                <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                              </span>
                            </th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Tgl. Jatuh Tempo</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Nama Toko</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Nama Sales</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">No. Invoice</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">No. BPB</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Total</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Tgl. Input</th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Titip Tagih</th>
                            <!-- <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;"></th> -->
                            <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                            <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                          </tr>
                          <tr v-for="(item, index) in invoice" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                            <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                              <v-checkbox
                                v-model="selected.is_titip"
                                :value="item.id"
                                :readonly="user.category_user_id === '1' ? false : user.category_user_title !== 'Finance Manager' ? true : false"
                              ></v-checkbox>
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                              {{ item.customer_code }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.due_date | date }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                              <a target="_blank" :href="`/customer/data/detail/${item.customer_id}`">
                                {{ item.store_name }}
                              </a>
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.orders_sales_name }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.number }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.bpb_number }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                              <!-- {{ item.total*1 | price }} -->
                              {{ (((item.orders_detail.reduce((sum, k) => sum + ((Math.round((k.price_per_pcs*1) * (k.total_in_dus*1)) * (k.qty_dus_diterima*1))), 0))) - item.orders_detail.reduce((sum, i) => sum + (i.discount*1), 0) - item.orders_detail.reduce((sum, i) => sum + ((i.strata_nominal*1) * (i.qty_dus_diterima*1)), 0)) | price }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.input_datetime | datetime }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                              <div v-if="item.is_titip === '1'">
                                <v-chip
                                  color="green"
                                  class="white--text px-4">
                                  Ya
                                </v-chip>
                              </div>
                              <div v-else>
                                <v-chip
                                  color="red"
                                  class="white--text px-4">
                                  Tidak
                                </v-chip>
                              </div>
                            </td>
                            
                            <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                            <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                              {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                              {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                            </td> -->
                          </tr>
                        </table>
                      </div>
                    </div>

                    <v-card-text
                      v-if="process.invoice" 
                      class="pb-0 my-4" 
                      style="height: 200px; display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <div class="mb-4 title">
                          Mohon Tunggu . . .
                        </div>

                        <v-progress-linear
                          :color="set_color"
                          indeterminate
                          rounded
                          height="10">
                        </v-progress-linear>
                      </div>
                    </v-card-text>

                    <v-card-text
                      v-if="invoice.length === 0"
                      class="pb-0 my-4" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <v-img 
                          class="mx-auto"
                          contain
                          alt="vuetify"
                          :width="90"
                          :height="90"
                          :src="require('@/assets/image/empty.png')">
                          <!-- <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template> -->
                        </v-img>
                        <div class="mt-3 fs-16">
                          Belum Ada Data
                        </div>
                      </div>
                    </v-card-text>
                  </div>
                </v-card-text>
              </v-card>

              <v-card
                flat
                class="mt-8"
                v-if="Object.keys(detail).length > 0"
                style="border-radius: 8px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div class="fs-18 input-label mb-4">
                    Status Pembayaran
                  </div>

                  <div>
                    <div v-if="detail.is_lunas === '1'">
                      <v-chip
                        color="green"
                        class="white--text px-4 font-weight-bold">
                        Status : Lunas
                      </v-chip>
                    </div>
                    <div v-else>
                      <v-chip
                        color="red"
                        class="white--text px-4 font-weight-bold">
                        Status : Belum Lunas
                      </v-chip>
                    </div>
                  </div>

                  <div class="mt-2" v-if="detail.bukti_lunas_url !== ''">
                    <img 
                      :src="detail.bukti_lunas_url"
                      alt="Mitra Warung" 
                      @click="dialog.bukti = true; selected.detail[0] = detail"
                      style="width: 250; height: 300; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />
                  </div>
                  <div class="mt-2" v-if="detail.bukti_lunas_url === ''">
                    -
                  </div>
                </v-card-text>
              </v-card>

              <v-card
                flat
                class="mt-8"
                v-if="Object.keys(detail).length > 0"
                style="border-radius: 8px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div class="fs-18 input-label mb-4">
                    Approval
                  </div>
                  <div>
                    <v-chip
                      class="mb-2"
                      :class="detail.status === 'proses' ? 'white--text' : detail.status === 'approved' ? 'white--text' : detail.status === 'persiapan' ? 'white--text' : detail.status === 'rejected' ? 'white--text' : 'grey'"
                      :color="detail.status === 'proses' ? 'blue' : detail.status === 'approved' ? 'green' : detail.status === 'persiapan' ? 'orange' : detail.status === 'rejected' ? 'red' : 'grey'"
                    >
                    Status Approval: {{ detail.status === 'proses' ? 'Proses' : detail.status === 'approved' ? 'Diterima' : detail.status === 'persiapan' ? 'Persiapan' : detail.status === 'rejected' ? 'Ditolak' : detail.status}}
                    </v-chip>
                    <div class="d-flex">
                      <div>
                        <table style="width: auto;">
                          <tr>
                            <td class="">
                              Piutang yg blm dibayar / Plafon
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold pb-1">
                              {{ ((detail.total_invoice*1)) | price }} / {{ (detail.customer_plafon*1) | price }}
                            </td>
                          </tr>
                          <tr>
                            <td class="">
                              Qty faktur yg blm dibayar / Kuota Faktur
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold pb-1">
                              {{ (detail.jumlah_invoice*1) | number }} / {{ (detail.customer_faktur*1) | number }}
                            </td>
                          </tr>
                          <!-- <tr>
                            <td class="">
                              Sisa Piutang
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold pb-1">
                              {{ (detail.total_invoice*1) | price }}
                            </td>
                          </tr> -->
                          <tr>
                            <td class="">
                              Sisa Plafon
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold pb-1">
                              <!-- {{ (detail.total_invoice*1) | price }} -->
                              {{ ((detail.customer_plafon*1) - (detail.total_invoice*1)) | price }}
                            </td>
                          </tr>
                          <tr>
                            <td class="">
                              TOP
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold pb-1">
                              {{ (detail.customer_term*1) | number }} Hari
                            </td>
                          </tr>
                          <tr>
                            <td class="">
                              Orderan saat ini
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold pb-1">
                              <!-- {{ (detail.total_nominal*1 - detail.total_discount*1) | price }} -->
                              {{ (detail.total_nominal*1 - (detail.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))), 0))) | price }}
                            </td>
                          </tr>
                        </table>
                      </div>
                      <!-- <div class="ml-10">
                        <table style="width: auto;">
                          <tr>
                            <td class="">
                              Plafon
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold">
                              {{ (detail.customer_plafon*1) | price }}
                            </td>
                          </tr>
                          <tr>
                            <td class="">
                              Faktur
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold">
                              {{ (detail.customer_faktur*1) | number }}
                            </td>
                          </tr>
                          <tr>
                            <td class="">
                              TOP
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold">
                              {{ (detail.customer_term*1) | number }} Hari
                            </td>
                          </tr>
                        </table>
                      </div> -->
                    </div>
                  </div>
                  <!-- <v-divider class="my-4"></v-divider> -->
                  <div>
                    <!-- <div>
                      Status Approval
                    </div>
                    
                    <div class="fs-16 label-input">
                      {{ detail.status === 'proses' ? 'Proses' : detail.status === 'approved' ? 'Diterima' : detail.status === 'persiapan' ? 'Persiapan' : detail.status === 'rejected' ? 'Ditolak' : detail.status}}
                    </div> -->
                  </div>
                  <div class="" v-if="detail.status === 'rejected'">
                    <div>
                      Alasan
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.rejected_reason }}
                    </div>
                  </div>
                  <v-row v-if="detail.status !== 'rejected'">

                    <v-col cols="12" md="3">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          color="#F06292"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            Supervisor
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          <div v-if="detail.order_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.order_approval.Supervisor.length < 1">
                            <v-checkbox
                              v-model="approved_by"
                              value="Supervisor"
                              color="white"
                              v-on:change="toChange()"
                              style="color: white !important"
                              hide-details
                            ></v-checkbox>
                          </div>

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          Supervisor
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.order_approval.Supervisor.length < 1 ? detail.approved_by === 'Supervisor,Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Supervisor,General Manager' || detail.approved_by === 'Supervisor,Finance Manager,General Manager' || detail.approved_by === 'Supervisor,Sales Manager,General Manager' ? detail.order_approval.General_Manager[0].user_name : '-' : detail.order_approval.Supervisor[0].user_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b v-if="detail.order_approval.Supervisor.length > 0">{{  detail.order_approval.Supervisor[0].orders_approval_datetime | datetime  }}</b>
                              <b v-else>
                                <span v-if="detail.approved_by === 'Supervisor,Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Supervisor,General Manager' || detail.approved_by === 'Supervisor,Finance Manager,General Manager' || detail.approved_by === 'Supervisor,Sales Manager,General Manager'">
                                  {{  detail.order_approval.General_Manager[0].orders_approval_datetime | datetime  }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </b>
                            </span>
                          </p>

                          <div v-if="detail.approved_reason.name === 'Supervisor' || detail.approved_reason.name === 'all'"  class="mt-2">

                            <div>
                              Alasan Approve
        
                            </div>
                            <div class="fs-16 label-input">
                              {{ detail.approved_reason.reason }}
                            </div>
                          </div>


                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          :color="set_color"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            Finance Manager
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          <div v-if="detail.order_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.order_approval.Finance_Manager.length < 1">
                            <v-checkbox
                              v-model="approved_by"
                              color="white"
                              :disabled="detail.order_approval.Supervisor.length < 1 ? approved_by.filter(item => item === 'Supervisor').length < 1 ? true : false : false"
                              value="Finance Manager"
                              hide-details
                            ></v-checkbox>
                          </div>

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          General Manager
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->
                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.order_approval.Finance_Manager.length < 1 ? detail.approved_by === 'Supervisor,Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Supervisor,Finance Manager,General Manager' || detail.approved_by === 'Finance Manager,General Manager' ? detail.order_approval.General_Manager[0].user_name : '-' : detail.order_approval.Finance_Manager[0].user_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b v-if="detail.order_approval.Finance_Manager.length > 0">{{  detail.order_approval.Finance_Manager[0].orders_approval_datetime | datetime  }}</b>
                              <b v-else>
                                <span v-if="detail.approved_by === 'Supervisor,Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Supervisor,Finance Manager,General Manager' || detail.approved_by === 'Finance Manager,General Manager'">
                                  {{  detail.order_approval.General_Manager[0].orders_approval_datetime | datetime  }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </b>
                            </span>
                          </p>

                          <div v-if="detail.approved_reason.name === 'Sales Manager' || detail.approved_reason.name === 'all'" class="mt-2">

                            <div>
                              Alasan Approve
        
                            </div>
                            <div class="fs-16 label-input">
                              {{ detail.approved_reason.reason }}
                            </div>
                          </div>


                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          color="#42A5F5"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            Sales Manager
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          <div v-if="detail.order_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.order_approval.Sales_Manager.length < 1">
                            <v-checkbox
                              v-model="approved_by"
                              color="white"
                              :disabled="detail.order_approval.Supervisor.length < 1 && detail.order_approval.Finance_Manager.length < 1 ? approved_by.filter(item => item === 'Finance Manager').length < 1 ? true : false : detail.order_approval.Supervisor.length < 1 && detail.order_approval.Finance_Manager.length > 0 ? approved_by.filter(item => item === 'Supervisor').length < 1 ? true : false : detail.order_approval.Supervisor.length > 0 && detail.order_approval.Finance_Manager.length < 1 ? approved_by.filter(item => item === 'Finance Manager').length < 1 ? true : false : false"
                              value="Sales Manager"
                              hide-details
                            ></v-checkbox>
                          </div>

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          Sales Manager
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.order_approval.Sales_Manager.length < 1 ? detail.approved_by === 'Supervisor,Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Sales Manager,General Manager' || detail.approved_by === 'Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Supervisor,Sales Manager,General Manager' ? detail.order_approval.General_Manager[0].user_name : '-' : detail.order_approval.Sales_Manager[0].user_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b v-if="detail.order_approval.Sales_Manager.length > 0">{{  detail.order_approval.Sales_Manager[0].orders_approval_datetime | datetime  }}</b>
                              <b v-else>
                                <span v-if="detail.approved_by === 'Supervisor,Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Sales Manager,General Manager' || detail.approved_by === 'Sales Manager,Finance Manager,General Manager' || detail.approved_by === 'Supervisor,Sales Manager,General Manager'">
                                  {{  detail.order_approval.General_Manager[0].orders_approval_datetime | datetime  }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </b>
                            </span>
                          </p>

                          <div v-if="detail.approved_reason.name === 'Sales Manager' || detail.approved_reason.name === 'all'" class="mt-2">

                            <div>
                              Alasan Approve
        
                            </div>
                            <div class="fs-16 label-input">
                              {{ detail.approved_reason.reason }}
                            </div>
                          </div>



                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          color="#66BB6A"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            General Manager
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          General Manager
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.order_approval.General_Manager.length < 1 ? '-' : detail.order_approval.General_Manager[0].user_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b v-if="detail.order_approval.General_Manager.length > 0">{{  detail.order_approval.General_Manager[0].orders_approval_datetime | datetime  }}</b>
                              <b v-else>-</b>
                            </span>
                          </p>


                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row v-if="detail.status === 'rejected'">
                    <v-col cols="12" md="4">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          :color="set_color"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            Staff yg Menolak
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          <!-- <div v-if="detail.customer_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.customer_approval.Supervisor.length < 1">
                            <v-checkbox
                              v-model="approve_name"
                              v-on-change="$emit('approved', approve_name)"
                              value="Supervisor"
                              color="white"
                              style="color: white !important"
                              hide-details
                            ></v-checkbox>
                          </div> -->

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          Supervisor
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.rejected_user_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b>{{ detail.rejected_date | date  }}</b>
                            </span>
                          </p>


                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              <div
                v-if="detail.order_approval !== undefined && Object.keys(detail.order_approval).length > 0 && !process.load && detail.status === 'proses'">

                <div
                  v-if="user.category_user_title === 'Supervisor' && detail.order_approval.Supervisor.length < 1  && detail.approved_by !== 'Supervisor,Sales Manager,Finance Manager,General Manager' && detail.approved_by !== 'Supervisor,General Manager' && detail.approved_by !== 'Supervisor,Sales Manager,General Manager' && detail.approved_by !== 'Supervisor,Finance Manager,General Manager'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="((detail.customer_plafon*1) - (detail.total_invoice*1)) <  ((detail.total_nominal*1 - (detail.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))), 0)))) ? dialog.komfirmasi = true : dialog.status = true; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="dialog.status = true; reset(); message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    elevation="0"
                    color="warning"
                    class="fs-16 ml-4 white--text text-capitalize">
                    Ditolak
                  </v-btn>
                </div>

                <div
                  v-else-if="user.category_user_title === 'Sales Manager' && detail.order_approval.Sales_Manager.length < 1 && detail.approved_by !== 'Supervisor,Sales Manager,Finance Manager,General Manager' && detail.approved_by !== 'Sales Manager,General Manager' && detail.approved_by !== 'Supervisor,Sales Manager,General Manager' && detail.approved_by !== 'Sales Manager,Finance Manager,General Manager'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="((detail.customer_plafon*1) - (detail.total_invoice*1)) < ((detail.total_nominal*1 - (detail.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))), 0)))) ? dialog.komfirmasi = true : dialog.status = true; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="dialog.status = true; reset(); message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    elevation="0"
                    color="warning"
                    class="fs-16 ml-4 white--text text-capitalize">
                    Ditolak
                  </v-btn>
                </div>

                <div
                  v-else-if="user.category_user_title === 'Finance Manager' && detail.order_approval.Finance_Manager.length < 1 && detail.approved_by !== 'Supervisor,Sales Manager,Finance Manager,General Manager' && detail.approved_by !== 'Finance Manager,General Manager' && detail.approved_by !== 'Supervisor,Finance Manager,General Manager' && detail.approved_by !== 'Sales Manager,Finance Manager,General Manager'"
                  class="d-flex align-center">
                  <!-- v-else-if="user.category_user_title === 'Finance Manager' && detail.order_approval.Finance_Manager.length < 1 && detail.approved_by !== 'Supervisor,Sales Manager,Finance Manager,General Manager' && detail.approved_by !== 'Finance Manager,General Manager' && detail.approved_by !== 'Supervisor,Finance Manager,General Manager' && detail.approved_by !== 'Sales Manager,Finance Manager,General Manager'" -->
                  <v-btn 
                    @click="((detail.customer_plafon*1) - (detail.total_invoice*1)) < ((detail.total_nominal*1 - (detail.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))), 0)))) ? dialog.komfirmasi = true : dialog.status = true; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="dialog.status = true; reset(); message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    elevation="0"
                    color="warning"
                    class="fs-16 ml-4 white--text text-capitalize">
                    Ditolak
                  </v-btn>
                </div>
                
                <div
                  v-else-if="user.category_user_title === 'General Manager' && detail.order_approval.General_Manager.length < 1"
                  class="d-flex align-center">
                  <v-btn 
                    @click="((detail.customer_plafon*1) - (detail.total_invoice*1)) < ((detail.total_nominal*1 - (detail.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))), 0)))) ? dialog.komfirmasi = true : dialog.status = true ; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    v-if="detail.order_approval.Sales_Manager.length > 0 && detail.order_approval.Finance_Manager.length > 0 && detail.order_approval.Supervisor.length > 0 ? true : detail.order_approval.Sales_Manager.length > 0 && detail.order_approval.Finance_Manager.length < 1 && detail.order_approval.Supervisor.length < 1 ? approved_by.filter(item => item === 'Finance Manager').length > 0 ? true : false : detail.order_approval.Sales_Manager.length < 1 && detail.order_approval.Finance_Manager.length > 0 && detail.order_approval.Supervisor.length < 1 ? approved_by.filter(item => item === 'Sales Manager').length > 0 ? true : false : detail.order_approval.Sales_Manager.length < 1 && detail.order_approval.Finance_Manager.length < 1 && detail.order_approval.Supervisor.length > 0 ? approved_by.filter(item => item === 'Sales Manager').length > 0 ? true : false : detail.order_approval.Sales_Manager.length > 0 && detail.order_approval.Finance_Manager.length > 0 && detail.order_approval.Supervisor.length < 1 ? approved_by.filter(item => item === 'Supervisor').length > 0 ? true : false : detail.order_approval.Sales_Manager.length > 0 && detail.order_approval.Finance_Manager.length < 1 && detail.order_approval.Supervisor.length > 0 ? approved_by.filter(item => item === 'Finance Manager').length > 0 ? true : false : detail.order_approval.Sales_Manager.length < 1 && detail.order_approval.Finance_Manager.length > 0 && detail.order_approval.Supervisor.length > 0 ? approved_by.filter(item => item === 'Sales Manager').length > 0 ? true : false : detail.order_approval.Sales_Manager.length < 1 && detail.order_approval.Finance_Manager.length < 1 && detail.order_approval.Supervisor.length < 1 ? approved_by.filter(item => item === 'Sales Manager').length > 0 ? true : false : false"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="dialog.status = true; reset(); message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    elevation="0"
                    color="warning"
                    class="fs-16 ml-4 white--text text-capitalize">
                    Ditolak
                  </v-btn>  
                </div>
              </div>

              
              <v-btn
                to="/approval/order"
                color="red"
                elevation="0"
                :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
// import { filter } from "core-js/core/array";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false,
          komfirmasi: false,
          bukti: false
        },

        detail: {},

        rejected_reason: '',
        invoice: [],

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },
        selected: {
          detail: [],
          is_titip: []
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          load: false,

          image_url: false,
          invoice: false,
          pdf: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      toChange () {
        let approved_by = []
        if(this.approved_by.length > 0) {
          this.approved_by.map(item => {
            if(item !== 'Sales Manager') {
              approved_by.push(item)
            } 
          })
        }
        this.approved_by = approved_by
        // this.$emit('approved', this.approve_name)
      },
      async fetchDetail () {
        this.process.load = true
          this.process.invoice = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/order/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
            // this.detail.approved_by = 'supervisor'
            // this.detail.order_approval.Supervisor = [{
            //   datetime: new Date(),
            //   user_name: 'test'
            // }]
            // this.detail.order_approval.Sales_Manager = [{
            //   datetime: new Date(),
            // }]
            // this.detail.order_approval.Finance_Manager = [{
            //   datetime: new Date(),
            // }]
            this.detail.approved_reason = this.detail.approved_reason.length < 1 ? { name: '', reason: '' } : JSON.parse(this.detail.approved_reason)
            this.fetchInvoice()
          }
          this.process.load = false
        })
      },
      async fetchInvoice () {
          this.process.invoice = true

        let params = {
          customer_id: this.detail.customer_id,
          limit: 100000000,
          sort: `-is_titip`,
          status: 'belum lunas'
        }
        
        await get(`admin/customer_invoice/data`, { params })
        .then(response => {
          let res = response.data
          
          this.process.invoice = false
          
          this.invoice = []
          
          if (res.status === 200) {
            this.invoice = res.results.data
            this.selected.is_titip = this.invoice.filter(item => item.is_titip === '1').map(item => item.id)
          }
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      printPage() {
        // Create print content
        const printContent = this.generatePrintContent()
        
        // Open print window
        const printWindow = window.open('', '_blank')
        printWindow.document.write(printContent)
        printWindow.document.close()
        
        // Wait for content to load then print
        printWindow.onload = function() {
          printWindow.focus()
          printWindow.print()
          printWindow.close()
        }
      },

      async exportPDF() {
        this.process.pdf = true
        
        try {
          // Load html2pdf from CDN if not already loaded
          if (!window.html2pdf) {
            await this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js')
          }
          
          // Create element for PDF
          const element = document.createElement('div')
          element.innerHTML = this.generatePrintContent(true)
          document.body.appendChild(element)
          
          const opt = {
            margin: [6, 6, 6, 6],
            filename: `Order_${this.detail.number || 'detail'}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { 
              scale: 2,
              useCORS: true,
              logging: false
            },
            jsPDF: { 
              unit: 'mm', 
              format: 'a4', 
              orientation: 'portrait' 
            },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
          }
          
          await window.html2pdf().set(opt).from(element.querySelector('.print-container')).save()
          
          document.body.removeChild(element)
        } catch (error) {
          console.error('Error exporting PDF:', error)
          this.message.error = 'Gagal export PDF. Silakan coba lagi.'
        }
        
        this.process.pdf = false
      },

      loadScript(src) {
        return new Promise((resolve, reject) => {
          if (document.querySelector(`script[src="${src}"]`)) {
            resolve()
            return
          }
          const script = document.createElement('script')
          script.src = src
          script.onload = resolve
          script.onerror = reject
          document.head.appendChild(script)
        })
      },

      generatePrintContent(forPdf = false) {
        const detail = this.detail
        const invoice = this.invoice
        
        // Calculate totals
        const totalDiscount = detail.detail ? detail.detail.reduce((acc, item) => acc + (((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))), 0) : 0
        const totalNet = (detail.total_nominal*1) - totalDiscount
        
        // Calculate qty totals
        const totalQtyDus = detail.detail ? detail.detail.reduce((acc, item) => (item.detail_total_in_dus * 1) > 1 ? acc + item.detail_qty_dus : acc, 0) : 0
        const totalQtyLusin = detail.detail ? detail.detail.reduce((acc, item) => acc + item.detail_qty_lusin, 0) : 0
        const totalQtyPcs = detail.detail ? (detail.detail.reduce((acc, item) => (item.detail_total_in_dus * 1) === 1 ? acc + item.detail_qty_dus : acc, 0) + detail.detail.reduce((acc, item) => acc + item.detail_qty_pcs, 0)) : 0
        const totalItems = detail.detail ? detail.detail.length : 0
        
        // Format date helper - handle various timestamp formats
        const formatDate = (timestamp) => {
          if (!timestamp) return '-'
          let date
          // Check if timestamp is string date format (e.g., "2024-12-17")
          if (typeof timestamp === 'string' && timestamp.includes('-')) {
            date = new Date(timestamp)
          } else {
            // Unix timestamp - check if seconds or milliseconds
            const ts = Number(timestamp)
            date = new Date(ts < 10000000000 ? ts * 1000 : ts)
          }
          if (isNaN(date.getTime())) return '-'
          return date.toLocaleDateString('id-ID', { day: '2-digit', month: '2-digit', year: 'numeric' })
        }
        
        const formatDateTime = (timestamp) => {
          if (!timestamp) return '-'
          let date
          // Check if timestamp is string date format
          if (typeof timestamp === 'string' && timestamp.includes('-')) {
            date = new Date(timestamp)
          } else {
            // Unix timestamp - check if seconds or milliseconds
            const ts = Number(timestamp)
            date = new Date(ts < 10000000000 ? ts * 1000 : ts)
          }
          if (isNaN(date.getTime())) return '-'
          
          const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
          const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
          
          const dayName = days[date.getDay()]
          const day = String(date.getDate()).padStart(2, '0')
          const month = months[date.getMonth()]
          const year = date.getFullYear()
          const hours = String(date.getHours()).padStart(2, '0')
          const minutes = String(date.getMinutes()).padStart(2, '0')
          
          return `${dayName}, ${day} ${month} ${year}, ${hours}:${minutes}`
        }
        
        const formatPrice = (value) => {
          if (!value) return 'Rp 0'
          return 'Rp ' + Number(value).toLocaleString('id-ID')
        }
        
        const formatNumber = (value) => {
          if (!value) return '0'
          return Number(value).toLocaleString('id-ID')
        }

        // Generate product rows
        let productRows = ''
        if (detail.detail && detail.detail.length > 0) {
          detail.detail.forEach((item, index) => {
            const qty = `${(item.detail_total_in_dus*1) === 1 ? 0 : item.detail_qty_dus}.${item.detail_qty_lusin}.${(item.detail_total_in_dus*1) === 1 ? item.detail_qty_dus : item.detail_qty_pcs}`
            
            let pricePerUnit = 0
            if (item.detail_qty_pcs !== 0) {
              pricePerUnit = item.detail_price_per_pcs
            } else if (item.detail_qty_lusin !== 0) {
              pricePerUnit = item.detail_price_per_pcs * 12
            } else if (item.detail_qty_dus !== 0) {
              pricePerUnit = Math.round(item.detail_price_per_pcs * item.detail_total_in_dus)
            }
            
            const hargaBruto = (item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1)
            const diskonPromo = item.detail_discount*1
            const diskonStrata = (item.detail_strata_nominal*1) * (item.detail_qty_dus)
            const hargaNet = hargaBruto - diskonPromo - diskonStrata
            
            productRows += `
              <tr>
                <td>${item.detail_varian_sku}</td>
                <td>${item.detail_varian_name}</td>
                <td style="text-align: center;">${qty}</td>
                <td style="text-align: right;">${formatNumber(pricePerUnit)}</td>
                <td style="text-align: right;">${formatPrice(hargaBruto)}</td>
                <td style="text-align: right;">${formatPrice(diskonPromo)}</td>
                <td style="text-align: right;">${formatPrice(diskonStrata)}</td>
                <td style="text-align: right;">${formatPrice(hargaNet)}</td>
              </tr>
            `
          })
        }

        // Generate invoice rows
        let invoiceRows = ''
        if (invoice && invoice.length > 0) {
          invoice.forEach((item) => {
            const total = (((item.orders_detail.reduce((sum, k) => sum + ((Math.round((k.price_per_pcs*1) * (k.total_in_dus*1)) * (k.qty_dus_diterima*1))), 0))) - item.orders_detail.reduce((sum, i) => sum + (i.discount*1), 0) - item.orders_detail.reduce((sum, i) => sum + ((i.strata_nominal*1) * (i.qty_dus_diterima*1)), 0))
            
            invoiceRows += `
              <tr>
                <td>${item.customer_code}</td>
                <td>${formatDate(item.due_date)}</td>
                <td>${item.store_name}</td>
                <td>${item.orders_sales_name}</td>
                <td>${item.number}</td>
                <td>${item.bpb_number || '-'}</td>
                <td style="text-align: right;">${formatPrice(total)}</td>
                <td style="text-align: center;">${item.is_titip === '1' ? 'Ya' : 'Tidak'}</td>
              </tr>
            `
          })
        }

        // Get approval status
        const getStatusLabel = (status) => {
          switch(status) {
            case 'proses': return 'Proses'
            case 'approved': return 'Diterima'
            case 'persiapan': return 'Persiapan'
            case 'rejected': return 'Ditolak'
            default: return status || '-'
          }
        }

        const getStatusColor = (status) => {
          switch(status) {
            case 'proses': return '#2196F3'
            case 'approved': return '#4CAF50'
            case 'persiapan': return '#FF9800'
            case 'rejected': return '#f44336'
            default: return '#9E9E9E'
          }
        }

        // Get approval info
        const getApprovalName = (type) => {
          if (detail.order_approval && detail.order_approval[type] && detail.order_approval[type].length > 0) {
            return detail.order_approval[type][0].user_name || '-'
          }
          return '-'
        }

        const getApprovalDate = (type) => {
          if (detail.order_approval && detail.order_approval[type] && detail.order_approval[type].length > 0) {
            return formatDateTime(detail.order_approval[type][0].orders_approval_datetime)
          }
          return '-'
        }

        return `
          <!DOCTYPE html>
          <html>
          <head>
            <meta charset="utf-8">
            <title>Detail Order - ${detail.number || ''}</title>
            <style>
              * { margin: 0; padding: 0; box-sizing: border-box; }
              body { font-family: Arial, sans-serif; font-size: 11px; color: #000; line-height: 1.3; }
              .print-container { padding: 4px 8px; max-width: 210mm; margin: 0 auto; }
              .header { margin-bottom: 15px; padding-bottom: 10px; border-bottom: 3px double #000; }
              .header h1 { font-size: 18px; font-weight: bold; margin-bottom: 2px; }
              .header p { font-size: 11px; margin: 1px 0; }
              .doc-title { text-align: center; margin: 15px 0 15px 0; font-size: 13px; font-weight: bold; }
              .section { margin-bottom: 32px; }
              .section-title { font-size: 11px; font-weight: bold; background: #f0f0f0; padding: 6px 10px; margin-bottom: 12px; border-left: 3px solid #333; }
              .info-grid { display: flex; justify-content: space-between; gap: 15px; font-size: 10px; }
              .info-box { flex: 1; }
              .info-row { display: flex; margin-bottom: 2px; }
              .info-label { width: 110px; }
              .info-value { flex: 1; font-weight: 600; }
              table { width: 100%; border-collapse: collapse; font-size: 9px; }
              th { background: #e8e8e8; border: .5px solid #999; padding: 4px 3px; text-align: center; font-weight: 600; }
              td { border: .5px solid #999; padding: 3px 4px; }
              .summary-box { display: flex; justify-content: space-between; align-items: flex-start; margin-top: 8px; font-size: 10px; }
              .summary-table { border-collapse: collapse; }
              .summary-table td { padding: 2px 8px; border: none; }
              .summary-table .label { text-align: left; }
              .summary-table .value { text-align: right; font-weight: 600; }
              .status-badge { display: inline-block; padding: 2px 8px; border-radius: 3px; color: white; font-weight: 600; font-size: 9px; }
              .approval-grid { display: flex; gap: 8px; }
              .approval-card { flex: 1; border: 1px solid #ccc; font-size: 9px; }
              .approval-header { padding: 4px; color: white; font-weight: 600; text-align: center; }
              .approval-body { padding: 6px; }
              .approval-body p { margin-bottom: 2px; }
              .print-date { text-align: right; font-size: 9px; color: #666; margin-top: 10px; border-top: 1px dashed #ccc; padding-top: 5px; }
              .info-table { width: 100%; font-size: 10px; margin-bottom: 8px; }
              .info-table td { padding: 2px 4px; vertical-align: top; }
              .info-table .lbl { width: 120px; }
              @media print { body { print-color-adjust: exact; -webkit-print-color-adjust: exact; } }
            </style>
          </head>
          <body>
            <div class="print-container">
              <div class="header">
                <h1>PT. MEGA VICTORIA NIAGA</h1>
                <p>Jl. Rawang Sari Rt 29, RW 07, Kel Tanah Mas. Km 18</p>
                <p>Banyuasin Sumatera Selatan</p>
                <p>Telp. 0838 2619 9000</p>
              </div>
              
              <div class="doc-title">DETAIL ORDER</div>

              <!-- Customer & Order Info -->
              <div class="section">
                <div class="section-title">INFORMASI ORDER</div>
                <table class="info-table" style="border: none;">
                  <tr>
                    <td style="border: none; width: 50%; vertical-align: top;">
                      <table style="border: none; width: 100%;">
                        <tr><td class="lbl" style="border:none;">Customer</td><td style="border:none;">: <strong>${detail.customer_name || '-'}</strong></td></tr>
                        <tr><td class="lbl" style="border:none;">Alamat</td><td style="border:none; text-transform: lowercase;">: ${detail.shipping_address || ''}, kel. ${detail.shipping_village || ''}, kec. ${detail.shipping_subdistrict || ''}, Kab. ${detail.shipping_city || ''} - ${detail.shipping_province || ''}</td></tr>
                        <tr><td class="lbl" style="border:none;">Nama Toko</td><td style="border:none;">: ${detail.store_name || '-'}</td></tr>
                        <tr><td class="lbl" style="border:none;">Tipe Toko</td><td style="border:none;">: ${detail.store_type || '-'}</td></tr>
                      </table>
                    </td>
                    <td style="border: none; width: 50%; vertical-align: top;">
                      <table style="border: none; width: 100%;">
                        <tr><td class="lbl" style="border:none;">No. Order</td><td style="border:none;">: <strong>${detail.number || '-'}</strong></td></tr>
                        <tr><td class="lbl" style="border:none;">Tanggal Order</td><td style="border:none;">: ${formatDateTime(detail.input_datetime)}</td></tr>
                        <tr><td class="lbl" style="border:none;">Nama Sales</td><td style="border:none;">: ${detail.sales_name || '-'}</td></tr>
                        <tr><td class="lbl" style="border:none;">Order By</td><td style="border:none;">: ${detail.orders_by === 'sales' ? detail.sales_name : detail.orders_by === 'customer' ? detail.customer_name : detail.orders_by || '-'}</td></tr>
                        <tr><td class="lbl" style="border:none;">Rencana Kirim</td><td style="border:none;">: ${detail.delivery_plan_date ? formatDate(detail.delivery_plan_date) : '-'}</td></tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>

              <!-- Product Table -->
              <div class="section">
                <div class="section-title">DETAIL PRODUK</div>
                <table>
                  <thead>
                    <tr>
                      <th style="width: 80px;">Kode</th>
                      <th>Nama Barang</th>
                      <th style="width: 50px;">Qty</th>
                      <th style="width: 70px;">Hrg/Unit</th>
                      <th style="width: 80px;">Bruto</th>
                      <th style="width: 70px;">Disc Promo</th>
                      <th style="width: 70px;">Disc Strata</th>
                      <th style="width: 80px;">Netto</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${productRows}
                  </tbody>
                </table>
                
                <div class="summary-box">
                  <div>Total Qty: <strong>${totalQtyDus}.${totalQtyLusin}.${totalQtyPcs}</strong> | Total Item: <strong>${totalItems}</strong></div>
                  <table class="summary-table">
                    <tr><td class="label">Bruto</td><td class="value">${formatPrice(detail.total_nominal)}</td></tr>
                    <tr><td class="label">Diskon</td><td class="value">${formatPrice(totalDiscount)}</td></tr>
                    <tr style="border-top: 1px solid #000;"><td class="label"><strong>NETTO</strong></td><td class="value"><strong>${formatPrice(totalNet)}</strong></td></tr>
                  </table>
                </div>
              </div>

              <!-- Titip Tagih Section -->
              ${invoice && invoice.length > 0 ? `
              <div class="section">
                <div class="section-title">TITIP TAGIH</div>
                <table>
                  <thead>
                    <tr>
                      <th>Kode</th>
                      <th>Jatuh Tempo</th>
                      <th>Toko</th>
                      <th>Sales</th>
                      <th>No. Invoice</th>
                      <th>No. BPB</th>
                      <th>Total</th>
                      <th>Titip</th>
                    </tr>
                  </thead>
                  <tbody>${invoiceRows}</tbody>
                </table>
              </div>
              ` : ''}

              <!-- Status & Approval in 2 columns -->
              <div style="display: flex; gap: 15px; margin-bottom: 24px;">
                <div style="flex: 1;">
                  <div class="section-title">STATUS PEMBAYARAN</div>
                  <span class="status-badge" style="background-color: ${detail.is_lunas === '1' ? '#4CAF50' : '#e53935'};">
                    ${detail.is_lunas === '1' ? '✓ LUNAS' : '✗ BELUM LUNAS'}
                  </span>
                </div>
                <div style="flex: 1;">
                  <div class="section-title">STATUS APPROVAL</div>
                  <span class="status-badge" style="background-color: ${getStatusColor(detail.status)};">
                    ${getStatusLabel(detail.status).toUpperCase()}
                  </span>
                </div>
              </div>

              <!-- Approval Info -->
              <div class="section">
                <div class="section-title">INFO APPROVAL</div>
                <table style="font-size: 9px; margin-bottom: 8px;">
                  <tr>
                    <td style="width: 50%; padding: 2px 4px;">Piutang / Plafon</td>
                    <td style="padding: 2px 4px;">: <strong>${formatPrice(detail.total_invoice)} / ${formatPrice(detail.customer_plafon)}</strong></td>
                  </tr>
                  <tr>
                    <td style="padding: 2px 4px;">Qty Faktur / Kuota</td>
                    <td style="padding: 2px 4px;">: <strong>${formatNumber(detail.jumlah_invoice)} / ${formatNumber(detail.customer_faktur)}</strong></td>
                  </tr>
                  <tr>
                    <td style="padding: 2px 4px;">Sisa Plafon</td>
                    <td style="padding: 2px 4px;">: <strong>${formatPrice((detail.customer_plafon*1) - (detail.total_invoice*1))}</strong></td>
                  </tr>
                  <tr>
                    <td style="padding: 2px 4px;">TOP</td>
                    <td style="padding: 2px 4px;">: <strong>${formatNumber(detail.customer_term)} Hari</strong></td>
                  </tr>
                  <tr>
                    <td style="padding: 2px 4px;">Order Saat Ini</td>
                    <td style="padding: 2px 4px;">: <strong>${formatPrice(totalNet)}</strong></td>
                  </tr>
                </table>

                ${detail.status === 'rejected' ? `
                <div style="background: #ffebee; padding: 4px 8px; border-left: 3px solid #e53935; margin-bottom: 8px; font-size: 9px;">
                  <strong>Alasan Penolakan:</strong> ${detail.rejected_reason || '-'}
                </div>
                ` : ''}

                <div class="approval-grid">
                  <div class="approval-card">
                    <div class="approval-header" style="background: #F06292;">Supervisor</div>
                    <div class="approval-body">
                      <p><strong>${getApprovalName('Supervisor')}</strong></p>
                      <p>${getApprovalDate('Supervisor')}</p>
                    </div>
                  </div>
                  <div class="approval-card">
                    <div class="approval-header" style="background: #718EBF;">Finance Mgr</div>
                    <div class="approval-body">
                      <p><strong>${getApprovalName('Finance_Manager')}</strong></p>
                      <p>${getApprovalDate('Finance_Manager')}</p>
                    </div>
                  </div>
                  <div class="approval-card">
                    <div class="approval-header" style="background: #42A5F5;">Sales Mgr</div>
                    <div class="approval-body">
                      <p><strong>${getApprovalName('Sales_Manager')}</strong></p>
                      <p>${getApprovalDate('Sales_Manager')}</p>
                    </div>
                  </div>
                  <div class="approval-card">
                    <div class="approval-header" style="background: #66BB6A;">General Mgr</div>
                    <div class="approval-body">
                      <p><strong>${getApprovalName('General_Manager')}</strong></p>
                      <p>${getApprovalDate('General_Manager')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="print-date">
                Dicetak: ${new Date().toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
              </div>
            </div>
          </body>
          </html>
        `
      },

      async save () {
        this.message.error = ''
        const isValid = this.message.status === 'terima' ? this.approved_by.length > 0 ? await this.$refs.form.validate() : true : await this.$refs.form.validate()
        if (isValid) {
          

        this.process.form = true
        let approved_reason = {
          name: '',
          reason: ''
        }
        if (this.message.status === 'terima') {
          if(this.approved_by.length === 1 && this.approved_by[0] === 'Supervisor') {

            approved_reason = {
              name: 'Supervisor',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length === 1 && this.approved_by[0] === 'Sales Manager') {
            approved_reason = {
              name: 'Sales Manager',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length === 1 && this.approved_by[0] === 'Finance Manager') {
            approved_reason = {
              name: 'Finance Manager',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length > 1) {
            approved_reason = {
              name: 'all',
              reason: this.approved_reason
            }
          } 

        }
        
        await post(`admin/order/approval`, {
          data: {
            id: this.detail.id,
            status: this.message.status === 'terima' ? 'approved' : 'rejected',
            approved_by: this.message.status === 'terima' ? this.user.category_user_title === 'General Manager' ? 'Supervisor,Sales Manager,Finance Manager,General Manager' : this.user.category_user_title : '',
            approved_reason: this.detail.approved_reason.name === '' ? JSON.stringify(approved_reason) : JSON.stringify(this.detail.approved_reason),
            rejected_reason: this.rejected_reason,
            invoice_id_array: this.selected.is_titip
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      }
    }
  }
</script>


<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    /* width: 100%; */
  }

  .wrapper-detail-order { 
    overflow-y: auto; 
    height: 100% 
  } 

  .wrapper-detail-order-none { 
    /* overflow-y: auto; 
    height: calc(100vh - 270px);  */
  } 

  .wrapper-detail-order th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }

  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}

  .border-radius-card-8 {
    border-radius: 8px;
  }
</style>